__webpack_require__.p = "https://release.hb.hk.jewelverse.com/pr12/";